import { IButtonType } from "src/app/interfaces/components/button.interface";
import { IContentAreaActionClick, TContentAreaAction } from "src/app/interfaces/components/content-area.interface";

export const contentAreaActions: IContentAreaActionClick<TContentAreaAction>[] = [
  { type: 'back', label: 'CONTENT_AREA.BACK' },
];

export const buttonsEmployeeForm: IButtonType[] =
[
  'cancel',
  'save'
];
